import { createStyles } from "@envestnet/envreact-component-library";
import type { Theme, WithStyles } from "@envestnet/envreact-component-library";

const styles = (theme: Theme) =>
  createStyles({
    container: {
      height: "98px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "0 40px",
      backgroundColor: theme.colors.background,
    },
    logo: {
      margin: "24px 0",
      height: "50px",
      width: "160px",
    },
    buttonContainer: {
      display: "flex",
    },
    headerBtn: {
      color: theme.colors.textSubtle,
      ...theme.fonts.p2,
      fontFamily: "Red Hat Display",
      marginLeft: "16px",
      padding: "8px",
      "&:focus": {
        textDecoration: "none !important",
        outline: `1px solid ${theme.colors.action}`,
        boxShadow: "none",
        borderRadius: "2px",
        padding: "8px",
        boxSizing: "border-box",
      },
      "&:hover": {
        textDecoration: "none !important",
        color: theme.colors.action,
      },
    },
    themeButton: {
      marginLeft: "16px",
      marginTop: "7px",
    },
    popoverClass: {
      backgroundColor: theme.colors.background,
    },
    popoverContainer: {
      display: "flex",
      flexDirection: "column",
      minWidth: "200px",
      maxWidth: "400px",
      backgroundColor: theme.colors.background,
    },
    popoverItem: {
      display: "flex",
      flexDirection: "column",
    },
    popoverItemLabel: {
      color: theme.colors.textSubtle,
      fontWeight: 700,
      fontSize: "14px",
      lineHeight: "19px",
      fontFamily: "Red Hat Display",
    },
    popoverItemValue: {
      color: theme.colors.textSubtle,
      fontWeight: 500,
      fontFamily: "Red Hat Display",
      fontSize: "14px",
      lineHeight: "19px",
      cursor: "default",
    },
    userAvatar: {
      height: "40px",
      width: "40px",
      borderRadius: "50%",
      backgroundColor: theme.colors.action,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: theme.colors.textPrimaryAction,
      ...theme.fonts.h4,
      fontSize: "15px",
      marginRight: "16px",
    },
    userContainer: {
      width: "40px",
      height: "40px",
      cursor: "pointer",
    },
    skeleton: {
      marginTop: "12px",
      marginLeft: "12px",
    },
  });

export type Styles = WithStyles<typeof styles>;
export default styles;
